import { FooterController } from "./footer.controller";

export class FooterComponent {
  controller: any = FooterController;
  templateUrl: string = "/html/components/footer";
}

angular.module("BookingApp").component("footerComponent", new FooterComponent());
